import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-6">
              Contact Us
            </h2>
            <p className="text-gray-700 mb-8">
             Switch to renewable energy today with Kyra Green Energy Solution. Whether you’re looking for a home setup, an industrial solution, or dealership opportunities, we’ve got you covered.
            </p>

            <div className="space-y-4 text-gray-700">
              <div className="flex items-center">
                <span className="text-brand-green text-xl">📍</span>
                <p>
                  76, 1st Floor, Kundrathur Main Road,
                  <br />
                  Mangadu, Chennai - 600122
                </p>
              </div>

              <div className="flex items-center">
                <span className="font-medium mr-2">📞 Phone:</span>
                <span>+91-9791188770</span>
              </div>
              <div className="flex items-center">
                <span className="font-medium mr-2">✉️ Email:</span>
                <span>kyragreenenergysolution@gmail.com</span>
              </div>
            </div>

            {/* Navigate to /contact */}
            <button
              className="mt-8 text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors bg-brand-green"
                onClick={handleClick}
            >
              Request a Free Consultation
            </button>
          </div>

          <div className="flex justify-center">
            <img
              src="/solar-energy-illustration.png"
              alt="Contact illustration"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
